import { render, staticRenderFns } from "./VehicleFormInfo.vue?vue&type=template&id=323481cc&scoped=true&"
import script from "./VehicleFormInfo.vue?vue&type=script&lang=ts&"
export * from "./VehicleFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleFormInfo.vue?vue&type=style&index=0&id=323481cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323481cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
